export default __webpack_public_path__ + "static/media/dentaverse3.4cc037d5.PNG";